import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const SnowflakeSqlBindSchema = z.union([
  z.string(),
  z.number(),
  z.array(z.union([z.string(), z.number()])),
]);

export const getCustomReportDebug = unaryRpc({
  name: "getCustomReportDebug" as const,
  input: z.object({
    id: z.string().trim().min(1),
    teamId: z.string().trim().optional(),
  }),
  output: z.object({
    valid: z.boolean(),
    rowId: z.string().nullable(),
    publicId: z.string().nullable(),
    found: z.boolean(),
    error: z.string().nullable(),
    report: z
      .object({
        teamId: z.string(),
        title: z.string().nullable(),
        status: z.enum(["preparing", "ready", "failed"]),
        requestedQuestion: z.string(),
        reportSpec: z.string().nullable(),
        explanation: z.string().nullable(),
        errorMessage: z.string().nullable(),
        createdAt: z.date(),
        updatedAt: z.date(),
      })
      .nullable(),
    highLevelAst: z.object({
      available: z.boolean(),
      message: z.string().nullable(),
      value: z.unknown().nullable(),
    }),
    queryPlan: z.unknown().nullable(),
    queryPlanVersion: z.number().nullable(),
    snowflake: z
      .object({
        boundSql: z.string(),
        inlineSql: z.string().nullable(),
        bindings: z.array(SnowflakeSqlBindSchema),
        reportTimeZone: z.string(),
        warning: z.string().nullable(),
      })
      .nullable(),
  }),
});

export type GetCustomReportDebugInput = z.infer<
  typeof getCustomReportDebug.input
>;
export type GetCustomReportDebugOutput = z.infer<
  typeof getCustomReportDebug.output
>;
